import { Appendix } from "../../../../../../shared/entities/scripts/appendix";
import { Study } from "../../../../../../shared/entities/scripts/study";
import { FormatDate, GetDateFromString } from "../../../../../../shared/scripts/date-functions";
import { FormatNumberWithCommas } from "../../../../../../shared/scripts/number-functions";
import { RenderDateMDY } from "../../../../../../shared/scripts/table-functions";
import { SiteInfo } from "../../../../sites/shared/sites.entities";
import { InterventionEvent } from "./interventions.entities";
import { InterventionsLookup } from "./interventions.lookup";

export class InterventionsDialog {
    static table: any = undefined;

    static Initialize() {
        InterventionsDialog.table = $('#interventions-details-modal #dialog-details-table').DataTable({
            autoWidth: true,
            info: false,
            paging: false,
            scrollX: true,
            scrollY: '70vh',
            searching: false,
            columns: [
                { data: "Study", title: "Platform", className: "text-left font-size12 nowrap" },
                { data: "Appendix", title: "Trial", className: "text-left font-size12 nowrap" },
                { data: "SiteNumber", title: "Site", className: "text-left font-size12 nowrap" },
                { data: "Subject", title: "Participant", className: "text-left font-size12 nowrap" },
                /*{ data: "Consented", title: "Consented", className: "text-left font-size12 nowrap" }, */
                { data: "StartedIntervention", title: "Started Intervention", className: "text-left font-size12 nowrap" },
                { data: "InterventionStatus", title: "Intervention Status", className: "text-left font-size12 nowrap" },
                { data: "StudyStatus", title: "Study Status", className: "text-left font-size12 nowrap" },
                { data: "DnsInterventionReason", title: "DNS Intervention Reason", className: "DnsInterventionReason text-left font-size12 nowrap" },
                { data: "DisconInterventionReason", title: "Discontinued Intervention Reason", className: "DisconInterventionReason text-left font-size12 nowrap" },
                { data: "DncInterventionReason", title: "DNC Intervention Reason", className: "DncInterventionReason text-left font-size12 nowrap" },
                { data: "DncStudyReason", title: "DNC Study Reason", className: "DncStudyReason text-left font-size12 nowrap" },
                //{ data: "Subject", title: "Participant", className: "text-left font-size12 nowrap" },
            ],
            buttons: [
                {
                    extend: 'csv',
                    className: "btn btn-secondary",
                    text: '<i class="fas fa-file-download"></i>',
                    charset: 'utf-8',
                    title: "RECOVER-CT Interventions Details Export",
                }
            ],
        });
    }

    public static ShowDialog(interventions: InterventionEvent[]): void {
        let tableRows: InterventionDialogRow[] = interventions.map((v: InterventionEvent) => new InterventionDialogRow(v));

        if (InterventionsDialog.table == undefined) { InterventionsDialog.Initialize(); }

        InterventionsDialog.table.clear();
        InterventionsDialog.table.rows.add(tableRows).draw();

        $('#interventions-details-modal').on('shown.bs.modal', () => {
            InterventionsDialog.table.columns.adjust();
            $('#interventions-details-modal .dataTables_scrollBody').scrollTop(0);
            $('#interventions-details-modal #modal-title').text("Number of Intervention Events = " + FormatNumberWithCommas(interventions.length + ""));
        });

        $('#interventions-details-modal').modal('show');

        let showDnsReasonCol = false;
        let showDisconReasonCol = false;
        let showDncReasonCol = false;
        let showDncStudyReasonCol = false;

        tableRows.forEach(row => {
            if (row.DisconInterventionReason != "") showDisconReasonCol = true;
            if (row.DnsInterventionReason != "") showDnsReasonCol = true;
            if (row.DncInterventionReason != "") showDncReasonCol = true;
            if (row.DncStudyReason != "") showDncStudyReasonCol = true;
        });

        if (!showDnsReasonCol)      { $(".DnsInterventionReason").hide(); }     else { $(".DnsInterventionReason").show(); };
        if (!showDisconReasonCol)   { $(".DisconInterventionReason").hide(); }  else { $(".DisconInterventionReason").show(); };
        if (!showDncReasonCol)      { $(".DncInterventionReason").hide(); }     else { $(".DncInterventionReason").show(); };
        if (!showDncStudyReasonCol) { $(".DncStudyReason").hide(); }            else { $(".DncStudyReason").show(); };
       
    }
}

export class InterventionDialogRow {
    Study: string;
    SiteNumber: string;
    Appendix: string;
    //Consented: string;
    StartedIntervention: string;
    InterventionStatus: string;
    StudyStatus: string;
    DnsInterventionReason: string;
    DisconInterventionReason: string;
    DncInterventionReason: string;
    DncStudyReason: string;
    Subject: string;

    constructor(event: InterventionEvent) {
        this.Subject = event.SubjectId;
        this.Study = Study.GetStudyName(event.StudyId);
        this.Appendix = Appendix.GetAppendixName(event.AppendixId);
        this.SiteNumber = SiteInfo.FormatSiteNumber(event.SiteNumber);
        //this.Consented = InterventionsLookup.GetYesNoUnknown(event.Consented);
        this.StartedIntervention = InterventionsLookup.GetYesNoUnknown(event.StartedIntervention);
        this.InterventionStatus = InterventionsLookup.GetInterventionStatus(event.InterventionStatusId);
        this.StudyStatus = InterventionsLookup.GetStudyStatus(event.StudyStatusId);
        this.DnsInterventionReason = InterventionsLookup.GetDnsInterventionReason(event.DnsInterventionReasonId);
        this.DisconInterventionReason = InterventionsLookup.GetDisconInterventionReason(event.DisconInterventionReasonId);
        this.DncInterventionReason = InterventionsLookup.GetDncInterventionReason(event.DncInterventionReasonId);
        this.DncStudyReason = InterventionsLookup.GetDncStudyReason(event.DncStudyReasonId);
    }

}